module.exports = __webpack_public_path__ + "static/media/stream.0fa40b7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stream.svg
// module id = 2074
// module chunks = 0